import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output,
  SimpleChanges,
  TemplateRef,
  ViewChild
} from '@angular/core';
import {xCalendar} from "../utils/xCalendar";
import {CalEvent} from "../utils/model/CalEvent";
import {CalAttachment} from "../utils/model/CalAttachment";
import {BsModalRef, BsModalService} from "ngx-bootstrap/modal";
import {FileListComponent} from "inet-ui";

@Component({
    selector: 'calendar-attachment-list',
    templateUrl: './attachment-list.component.html',
    styleUrls: ['./attachment-list.component.scss']
})
export class AttachmentListComponent implements OnChanges, OnDestroy {
    @Input() calEvent?: CalEvent;
    @Input() fileEl?: HTMLInputElement;
    @Input() removable?: boolean;
    @ViewChild(FileListComponent) fileList!: FileListComponent;
    @Output() deleteAttachment = new EventEmitter<any>();
    files: any[] = [];
    modalRef!: BsModalRef;
    confirmMessage?: string;
    private _file: any;
    constructor(private modalService: BsModalService) {

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.calEvent) {
            this._attachmentToFiles();
        }
    }

    ngOnDestroy(): void {
        if (this.modalRef) {
            this.modalRef.hide();
        }
    }

    viewAttachment(file: any, event: any) {
        window.open(xCalendar.getFileViewUrl(file.data, '', event));
    }

    removeAttachment(file: any, template: TemplateRef<any>) {
        if (file.id) {
            this._file = file;
            this.confirmMessage = 'Tệp tin <b>"' + file.name + '"</b> sẽ bị xoá?';
            this.modalRef = this.modalService.show(template);
        } else {
            this.fileList.removeFile(file);
        }
    }

    removeFile() {
        if (!this._file) {
            return;
        }
        this.modalRef.hide();
        if(this.calEvent && this.calEvent.uuid) {
          this.deleteAttachment.emit({
            fileID: this._file.id,
            element: this.calEvent.uuid
          })
        }
        this.fileList.removeFile(this._file);
        this._file = null;
    }

    private _attachmentToFiles() {
        if (this.calEvent && this.calEvent.attachments) {
            this.files = this.calEvent.attachments.map((item: CalAttachment) => {
                return {
                    name: item.file,
                    type: item.mimetype,
                    size: item.size,
                    id: item.gridfsUUID,
                    data: item
                };
            });
        } else {
            this.files = [];
        }
    }
}
